import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "What We Do" },
  { to: "/work", label: "Our Work" },
  { to: "/party-kahan-hai", label: "Party Kahan Hai" },
  { to: "/home2plate", label: "Home2Plate" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        transition: "background 0.3s ease, border-color 0.3s ease, backdrop-filter 0.3s ease",
        background: scrolled ? "rgba(11,11,13,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid var(--oo-border)" : "1px solid transparent",
      }}
    >
      <div className="oo-container">
        <div className="flex items-center justify-between" style={{ height: 76 }}>
          <Logo />

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="hover-underline font-display text-sm font-medium"
                style={{
                  color: pathname === l.to ? "var(--oo-orange)" : "var(--oo-muted)",
                  transition: "color 0.25s ease",
                }}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <Link to="/contact" className="hidden lg:inline-flex btn-primary" style={{ padding: "11px 22px", fontSize: 14 }}>
            Let's Talk <ArrowUpRight size={16} />
          </Link>

          <button
            className="lg:hidden inline-flex items-center justify-center"
            style={{ color: "var(--oo-text)", width: 44, height: 44 }}
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className="lg:hidden overflow-hidden"
        style={{
          maxHeight: open ? 460 : 0,
          transition: "max-height 0.4s ease",
          background: "rgba(11,11,13,0.97)",
          backdropFilter: "blur(14px)",
          borderBottom: open ? "1px solid var(--oo-border)" : "none",
        }}
      >
        <div className="oo-container py-4 flex flex-col">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="font-display py-3 text-base"
              style={{
                color: pathname === l.to ? "var(--oo-orange)" : "var(--oo-text)",
                borderBottom: "1px solid var(--oo-border)",
              }}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary mt-4 justify-center">
            Let's Talk <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
